import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService, StateService } from '@cosmos/angular/utils';
import { environment } from 'environments/environment';
import { catchError, map, Observable } from 'rxjs';
import { File as FileModel } from '@cosmos/shared';


@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(
    //@InjectModel(File.name) private readonly fileModel: Model<File>,
    private http: HttpClient,
    private errorService: ErrorService,
    private stateService: StateService,
  ) { }

  uploadFile(uploadDestination: string, file: File[], id:string , services:string, filetype: string, company: string, context: string, project: string){
    const formData = new FormData();

    Array.from(file).forEach(element => {
      formData.append("file", element);
      formData.append("filename", element.name)
      const type = element.name.split('.')
      formData.append("filetype", type[type.length - 1])
    });


    formData.append("company", company);
    formData.append("owner", this.stateService.getCurrentUser()._id as string);
    formData.append("serviceId", id);
    formData.append("service", services);
    formData.append("context", context);
    formData.append("path", uploadDestination);
    formData.append("project", project);
    return this.http
    .post(`${environment.API_URL}` + '/upload', formData, {reportProgress: true, observe: 'events'})
      .pipe(
        map(response => {return response}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  sendFileByEmail(uploadDestination: string, id: string) {
    return this.http.get(`${environment.API_URL}/upload/email/${uploadDestination}/${id}`, {responseType :'blob', observe: "response"})
      .pipe(
        map(response => {
          return response;
        }),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      )
  }

  getFile( uploadDestination: string, id: string, type: string): Observable<HttpResponse<Blob> | string> {
    if(type === "pdf") { //As the pdf is displayed differently from the images, they must be processed differently, with an array buffer instead of a blob
      return this.http.get(`${environment.API_URL}/upload/${uploadDestination}/${id}`, {responseType :'blob', observe: "response"})
      .pipe(
        map(response => {
          return response;
        }),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      )
    }
    else {
      return this.http.get(`${environment.API_URL}/upload/${uploadDestination}/${id}`, {responseType :'blob', observe: "response"})
      .pipe(
        map(response => {
          const objectUrl = URL.createObjectURL(response.body as Blob);
          return objectUrl;
        }),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      )
    }

  }
  find(query=''): Observable<HttpResponse<FileModel[]>> {
    return this.http.get(`${environment.API_URL}/upload/${query}`, {observe: 'response'})
    .pipe(
      map(response => {return response as HttpResponse<FileModel[]>;}),
      catchError( (error) =>{this.errorService.handleError(error); throw error;})
    );
  }

  delete (filePath: string, id: string, name: string) {
    return this.http.delete(`${environment.API_URL}/upload/${filePath}/${id}/${name}`, {observe: "response"})
      .pipe(
        map(response => {
          return response;
        }),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      )
  }

  downloadCSVFromBlob(response: any) {
    const url = window.URL.createObjectURL(response.body);
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      link.setAttribute('href', url);
      link.setAttribute('download', response.headers.get('Content-Disposition').split('"')[1]);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // browser does not support download!
    }
  }

  downloadFromBlob(response: any) {
    const url = window.URL.createObjectURL(response.body);
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      link.setAttribute('href', url);
      link.setAttribute('target', 'blank');
      link.setAttribute('download', response.headers.get('Content-Disposition').split('=')[1]);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // browser does not support download!
    }
  }

  downloadFromBlobUrl(url: string) {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      link.setAttribute('href', url);
      link.setAttribute('target', 'blank');
      // link.setAttribute('download', response.headers.get('Content-Disposition').split('=')[1]);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // browser does not support download!
    }
  }
}


